var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBLBASEINFO" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && _vm.popupParam.envWasteVolumeId
                            ? _c("c-btn", {
                                attrs: { label: "LBLREMOVE", icon: "remove" },
                                on: { btnClicked: _vm.deleteData },
                              })
                            : _vm._e(),
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.mappingType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveInfo,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            editable:
                              _vm.editable && !_vm.popupParam.envWasteVolumeId,
                            type: "month",
                            label: "기준월",
                            name: "wasteYm",
                          },
                          model: {
                            value: _vm.data.wasteYm,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteYm", $$v)
                            },
                            expression: "data.wasteYm",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: {
                            editable:
                              _vm.editable && !_vm.popupParam.envWasteVolumeId,
                            required: true,
                            type: "edit",
                            name: "plantCd",
                          },
                          on: { input: _vm.getEmptyList2 },
                          model: {
                            value: _vm.data.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "plantCd", $$v)
                            },
                            expression: "data.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            editable:
                              _vm.editable && !_vm.popupParam.envWasteVolumeId,
                            data: _vm.data,
                            deptValue: "deptCd",
                            type: "dept_user",
                            label: "작성부서 & 작성자",
                            name: "userId",
                          },
                          model: {
                            value: _vm.data.userId,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "userId", $$v)
                            },
                            expression: "data.userId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            type: "number",
                            required: true,
                            editable: _vm.editable,
                            label: "운반횟수",
                            name: "wasteTransport",
                          },
                          model: {
                            value: _vm.data.wasteTransport,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteTransport", $$v)
                            },
                            expression: "data.wasteTransport",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "kg",
                            type: "number",
                            required: true,
                            editable: _vm.editable,
                            label: "생산량",
                            name: "salesVolume",
                          },
                          model: {
                            value: _vm.data.salesVolume,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "salesVolume", $$v)
                            },
                            expression: "data.salesVolume",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "원",
                            type: "number",
                            required: true,
                            editable: _vm.editable,
                            label: "처리단가",
                            name: "wasteUnit",
                          },
                          model: {
                            value: _vm.data.wasteUnit,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteUnit", $$v)
                            },
                            expression: "data.wasteUnit",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            suffix: "원",
                            type: "number",
                            required: true,
                            editable: _vm.editable,
                            label: "처리비용",
                            name: "wasteCost",
                          },
                          model: {
                            value: _vm.data.wasteCost,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "wasteCost", $$v)
                            },
                            expression: "data.wasteCost",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c("c-table", {
                ref: "table",
                attrs: {
                  title: "폐기물 발생량",
                  tableId: "processManual",
                  columns: _vm.grid.columns,
                  gridHeight: _vm.grid.height,
                  data: _vm.grid.data,
                  columnSetting: false,
                  isFullScreen: false,
                  usePaging: false,
                  expandAll: true,
                  hideBottom: true,
                  filtering: false,
                  isExcelDown: false,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }